var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 2,
    width: 24,
    height: 24,
    className: "Close_svg__icon Close_svg__icon-close"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.658 6.343 6.344 17.657m11.314 0L6.344 6.343",
    stroke: "currentColor"
  })));
};
export default SvgClose;